// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hr-0";
export var actionModalContentContainer = "_hr-1";
export var createTagButton = "_hr-2";
export var footerContainer = "_hr-7";
export var fullWidthDivider = "_hr-3";
export var hasCreateTagButton = "_hr-4";
export var noCreateTagButton = "_hr-5";
export var tagsContainer = "_hr-6";
export var tagsModalContentContainer = "_hr-8";